import { EMPTY_STRING, SETTING_UNITS_KEY } from '@src/core/config';
import { UnitType } from '@src/core/enums';
import { getUnitType } from '@src/core/features/settings/units';
import { arcToFixed } from "./arc-to-fixed";

export type ArcFormatOptions = {
  /** Value is in SI base units (m, m/s) and should be converted for Imperial display. */
  fromSi?: boolean;
};

export const arcSpatiumUnit = (unitType: UnitType = getUnitType()) => {
  if (unitType === UnitType.SI) return 'm';
  if (unitType === UnitType.IMPERIAL) return 'ft';
  return '';
};

export const arcSpatium = (
  value?: number | null | string,
  options?: ArcFormatOptions
) => {
  const payload = Number(value);
  const unitType = getUnitType();

  if (isNaN(payload)) return EMPTY_STRING;

  let display = payload;
  if (options?.fromSi && unitType === UnitType.IMPERIAL) {
    display = Number(arcToFixed(payload * 3.28084));
  } else {
    display = Number(arcToFixed(payload));
  }

  if (unitType === UnitType.SI) return arcToFixed(display) + ' m';
  if (unitType === UnitType.IMPERIAL) return arcToFixed(display) + ' ft';

  return EMPTY_STRING;
};
